module.exports = __webpack_public_path__ + "static/media/board_Neville_Ying.20c130b4.jpg";